import React from 'react';
import Menu from './Menu/Menu';
import { Outlet } from 'react-router-dom';
import ScrollToTop from './ScrollToTop';

const Layout = () => {
    return (
        <>
            <ScrollToTop />
            <Menu />
            <div className="App-content">
                <Outlet />
            </div>
        </>
    );
};

export default Layout;
